module.exports = __webpack_public_path__ + "img/banner-en.0366f304.jpg";